import { Button } from "@heroui/button";
import Link from "next/link";

import BgIntroductionGradient from "@/assets/illustrations/bg-introduction-gradient.png";
import styles from "@/styles/style.module.scss";
import MotionSection from "@/components/motion/section";

interface CardInfo {
  title: string;
  short_description: string;
}

export default function Introduction() {
  const cardInfos: CardInfo[] = [
    {
      title: "52%",
      short_description: "Faster Payment Collection",
    },
    {
      title: "30%",
      short_description: "Reduction in accounts receivable costs",
    },
  ];

  const CardInfo = ({ info }: { info: CardInfo }) => {
    return (
      <div className={styles.introduction__infos_item}>
        <h4 className={styles.text_gradient_primary}>{info.title}</h4>
        <h5 className="text-2xl">{info.short_description}</h5>
      </div>
    );
  };

  return (
    <div className={styles.introduction}>
      <div
        className={styles.introduction__background}
        style={{
          backgroundImage: `url(${BgIntroductionGradient.src})`,
        }}
      />
      <MotionSection directions="up">
        <div className={styles.introduction__content}>
          <h1 className={styles.text_super}>
            <span className={styles.text_gradient_primary}>Boost</span> Your
            Cashflow with zanbio&apos;s automated Accounts Receivable and
            Payable Solutions
          </h1>
          <h4 className={`lg:max-w-[720px] mt-4 ${styles.text_subtitle}`}>
            <b>Automate</b> Collections, <b>Predict</b> Cash Inflows,{" "}
            <b>Free up</b> Working Capital and <b>Optimize</b> Operational
            Efficiency
          </h4>

          <Button
            as={Link}
            className="bg-brand text-white h-[52px] text-sm px-[25px] mt-10 mb-[60px] text-lg"
            href="/book-a-call"
            title="Book a Call"
          >
            Book a Call
          </Button>

          <div className={styles.introduction__infos}>
            {cardInfos.map((info, index) => (
              <CardInfo key={`${info.title} with key ${index}`} info={info} />
            ))}
          </div>
        </div>
      </MotionSection>
    </div>
  );
}
